<div class="user-home-container">
  <!-- Boas-vindas -->
  <div class="header">
    <h2>Olá, {{ user.name }} 👋</h2>
    <p>Esses são os seus dados de desempenho atual</p>
  </div>

  <!-- Indicadores pessoais -->
  <section class="kpi-section">
    <mat-card class="kpi-card">
      <mat-icon>assignment_turned_in</mat-icon>
      <div>
        <p class="label">Metas Concluídas</p>
        <h3>{{ metas.length }}</h3>
      </div>
    </mat-card>

    <mat-card class="kpi-card">
      <mat-icon>pending_actions</mat-icon>
      <div>
        <p class="label">Tarefas Concluídas</p>
        <h3>{{ tarefas.length }}</h3>
      </div>
    </mat-card>

    <mat-card class="kpi-card">
      <mat-icon>trending_up</mat-icon>
      <div>
        <p class="label">Progresso Médio</p>
        <h3>{{ kpis.progresso }}%</h3>
      </div>
    </mat-card>

    <mat-card class="kpi-card">
      <mat-icon>description</mat-icon>
      <div>
        <p class="label">Docs Lidos</p>
        <h3>{{ kpis.docsLidos }}/{{ kpis.totalDocs }}</h3>
      </div>
    </mat-card>
  </section>

  <!-- Rotinas -->
  <section class="rotinas-section card">
    <div class="section-header">
      <h3>🔄 Suas Rotinas</h3>
      <span class="count-badge">{{ rotinas.length }}</span>
    </div>
    <p *ngIf="!rotinas.length" class="empty-state">Nenhuma rotina encontrada.</p>
    <div class="rotinas-scroll">
      <mat-card *ngFor="let rotina of rotinas" class="meta-card">
        <mat-card-header>
          <mat-card-title>{{ rotina.name }}</mat-card-title>
        </mat-card-header>
      </mat-card>
    </div>
  </section>

  <!-- Metas e Tarefas lado a lado -->
  <div class="metas-tarefas-row">
    <!-- Metas em andamento -->
    <section class="metas-section card">
      <h3>🎯 Suas Metas</h3>
      <p *ngIf="!metas.length" class="empty-state">Nenhuma meta encontrada.</p>
      <mat-card *ngFor="let meta of metas" class="meta-card">
        <mat-card-header>
          <mat-card-title>{{ meta.title }}</mat-card-title>
          <mat-card-subtitle>{{ meta.description }}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="meta-dates">
            <span *ngIf="meta.startDate"
              ><mat-icon>event</mat-icon> Início: {{ meta.startDate | date: "dd/MM/yyyy" }}</span
            >
            <span *ngIf="meta.endDate"
              ><mat-icon>event_available</mat-icon> Fim: {{ meta.endDate | date: "dd/MM/yyyy" }}</span
            >
          </div>
          <div class="meta-status">
            <span class="status-badge status-{{ meta.status?.toLowerCase() }}">{{ meta.status }}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </section>

    <!-- Tarefas -->
    <section class="tarefas-section card">
      <h3>✅ Suas Tarefas</h3>
      <p *ngIf="!tarefas.length" class="empty-state">Nenhuma tarefa encontrada.</p>
      <mat-card *ngFor="let tarefa of tarefas" class="meta-card">
        <mat-card-header>
          <mat-card-title>{{ tarefa.title }}</mat-card-title>
          <mat-card-subtitle>{{ tarefa.description }}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="meta-dates">
            <span *ngIf="tarefa.startDate"
              ><mat-icon>event</mat-icon> Início: {{ tarefa.startDate | date: "dd/MM/yyyy" }}</span
            >
            <span *ngIf="tarefa.endDate"
              ><mat-icon>event_available</mat-icon> Fim: {{ tarefa.endDate | date: "dd/MM/yyyy" }}</span
            >
          </div>
          <div class="meta-status">
            <span class="status-badge status-{{ tarefa.status?.toLowerCase() }}">{{ tarefa.status }}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </section>
  </div>

  <!-- Documentos pendentes -->
  <section class="documentos-section card">
    <h3>📄 Documentos Pendentes</h3>
    <div *ngIf="documentos.length; else todosLidos">
      <mat-list>
        <mat-list-item *ngFor="let doc of documentos">
          {{ doc.nome }}
          <button mat-button (click)="abrirDocumento(doc)">Ver</button>
        </mat-list-item>
      </mat-list>
    </div>
    <ng-template #todosLidos>
      <p>✅ Todos os documentos foram lidos!</p>
    </ng-template>
  </section>
</div>
